import { render } from "./Task.vue?vue&type=template&id=0f3a955e&scoped=true&ts=true"
import script from "./Task.vue?vue&type=script&lang=ts"
export * from "./Task.vue?vue&type=script&lang=ts"

import "./Task.vue?vue&type=style&index=0&id=0f3a955e&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1764364635178909029/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3a955e"]])

export default __exports__